import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, ButtonProps } from "reactstrap";

import { messages } from "../messages";

interface ExpandButtonProps {
    disabled?: boolean;
    expanded: boolean;
    toggleExpanded: () => void;
}

export const ExpandButton = ({ disabled, expanded, toggleExpanded }: ExpandButtonProps) => {
    const onClick = (event: React.MouseEvent) => {
        event.preventDefault();
        toggleExpanded();
    };
    const props: ButtonProps = {
        tag: "a",
        href: "#",
        color: expanded ? "secondary" : "primary",
        onClick,
        disabled,
    };
    const message = expanded ? messages.buttonShowFewer : messages.buttonShowMore;
    return (
        <Button {...props}>
            <FormattedMessage {...message} />
        </Button>
    );
};
